export default __webpack_public_path__ + "static/american_lfe-5879a83c6bf568fa12883aeb949cc1fb.png";